<script lang='ts'>
  import { Downloads } from '$lib/components/ui/downloads'
</script>

<Downloads releasesUrl={atob('aHR0cHM6Ly9hcGkuaGF5YXNlLndhdGNoL2xhdGVzdA==')} />
